import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RequestState {
    lastRequest?: () => void;
}

export const initialState: RequestState = {};

const requestSlice = createSlice({
    name: 'request',
    initialState,
    reducers: {
        setLastRequest(state, action: PayloadAction<() => void>) {
            state.lastRequest = action.payload;
        },
        clearLastRequests() {
            return initialState;
        }
    }
});

export const { setLastRequest, clearLastRequests } = requestSlice.actions;
export default requestSlice.reducer;
